import WorkoutShow from './WorkoutShow';

export default WorkoutShow;
